export default __webpack_public_path__ + "static/char-s-43-zh-Hant-471ff6a9bca8035bd7cbbc2a74ee5435.webp";